module.exports = __webpack_public_path__ + "media/img/iryo/infinita-bistro-2b5ff802a42cb148ead14b25824eaa69.png";